
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sandbox",
      function () {
        return require("private-next-pages/sandbox.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sandbox"])
      });
    }
  